<template>
    <v-container fluid>
        <v-btn icon @click="exportToPDF">
            <v-icon large> mdi-file-pdf-box </v-icon>
        </v-btn>
        <v-expansion-panels
            v-model="panel"
        >
            <v-expansion-panel>
                <v-expansion-panel-header class="card-title mt-1">
                    <v-row align="center">
                        <v-col cols="6">
                            Επιταγές
                            <v-icon color="black" class="px-4" @click.stop="togglePanel()">
                                mdi-tune
                            </v-icon>
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <filters
                        :filters="displayInfo"
                        @reloadFilters="reloadFilters"
                        @filterResults="filterResults"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-card v-if="Object.keys(totals).length > 0" class="py-7">
            <v-row>
                <v-col cols="4" align="center">
                    Μεικτά: {{ totals.total }}€
                </v-col>
                <v-col cols="4" align="center">
                    Καθαρά: {{ totals.totalAfterTaxes }}€
                </v-col>
                <v-col cols="4" align="center">
                    Τελικό: {{ totals.finalTotal }}€
                </v-col>
            </v-row>
        </v-card>
        <array-view
            :items="expenses"
            :headers="displayInfo.filter(element => element.showArray)"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
        />
    </v-container>
</template>

<script>
    import expenseService from '@/services/expense'
    import ArrayView from '@/components/ArrayView'
    import Filters from '@/components/Filters'
    import categoryService from '@/services/category'
    import chargeUnitService from '@/services/chargeUnit'
    import html2pdf from 'html2pdf.js'

    export default {
        name: 'Expense',
        components: { ArrayView, Filters },
        data: () => {
            return {
                successfullImport: null,
                expenses: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id',
                        showArray: true
                    },
                    {
                        text: 'Ημερομηνία Εξόδου',
                        value: 'expenseDate',
                        searchable: false,
                        type: 'date',
                        meta: 'from',
                        showArray: true
                    },
                    {
                        text: 'Ημερομηνία λήξης',
                        value: 'expenseInfo',
                        subLevel: 'checkExpirationDate',
                        level: 1,
                        searchable: false,
                        showArray: true
                    },
                    {
                        text: 'Μονάδα χρέωσης',
                        value: 'chargeUnit',
                        subLevel: 'title',
                        type: 'api',
                        level: 1,
                        data: null,
                        searchable: false,
                        showArray: true
                    },
                    {
                        text: 'Κατηγορία',
                        value: 'category',
                        subLevel: 'title',
                        type: 'api',
                        level: 1,
                        data: null,
                        searchable: false,
                        showArray: true
                    },
                    {
                        text: 'Κατάσταση',
                        value: 'status',
                        data: [
                            { displayValue: 'ΕΚΚΡΕΜΕΙ', value: 'PENDING' },
                            { displayValue: 'ΠΛΗΡΩΜΕΝΟ', value: 'PAID' }
                        ],
                        type: 'select',
                        searchable: false,
                        showArray: true
                    },
                    {
                        text: 'Μέθοδος πληρωμής',
                        value: 'paymentMethod',
                        data: [
                            { displayValue: 'ΜΕΤΡΗΤΑ', value: 'CASH' },
                            { displayValue: 'ΕΠΙΤΑΓΗ', value: 'CHECK' },
                            { displayValue: 'ΤΡΑΠΕΖΑ', value: 'BANK' }
                        ],
                        type: 'select',
                        searchable: false,
                        showArray: true
                    },
                    {
                        text: 'Σύνολο (€)',
                        value: 'amount',
                        searchable: false,
                        type: 'number',
                        showArray: true
                    },
                    {
                        text: 'Τίτλος',
                        value: 'title',
                        searchable: false,
                        type: 'simple',
                        showArray: true
                    },
                    {
                        text: 'Ημερομηνία λήξης επιταγής',
                        value: 'checkExpirationDate',
                        type: 'checkDate',
                        meta: 'from',
                        searchable: true,
                        showArray: false,
                        disabled: false,
                        single: true
                    },
                    {
                        text: 'Ημερομηνία λήξης επιταγής',
                        value: 'checkExpirationDate',
                        type: 'checkDate',
                        meta: 'to',
                        searchable: true,
                        showArray: false,
                        disabled: false,
                        single: true
                    },
                    {
                        text: 'Αριθμός επιταγής',
                        value: 'expenseInfo',
                        subLevel: 'checkNumber',
                        searchable: true,
                        type: 'simple',
                        showArray: true
                    }
                ],
                showImportDialog: false,
                size: 5,
                totalPages: 0,
                page: 1,
                panel: undefined,
                query: {},
                totals: {},
                sort: null
            }
        },
        watch: {
            panel() {
                if (this.panel === 0 && this.displayInfo[3].data === null && this.displayInfo[4].data === null) {
                    this.fetchAllCategories()
                    this.fetchAllChargeUnits()
                }
            },
            page() {
                var path = `/checks?page=${this.page}`
                if (this.$route.fullPath !== path) {
                    this.$router.push(path)
                }
            },
            size() {
                var path = `/checks?page=${this.page}&size=${this.size}`
                if (this.$route.fullPath !== path) {
                    this.$router.push(path)
                }
            }
        },
        created() {
            this.page = this.$route.query.page ? parseInt(this.$route.query.page) : this.page
            if (this.$store.getters.getFilters) {
                this.displayInfo = this.$store.getters.getFilters
            }
            if (this.$store.getters.getQuery) {
                this.query = this.$store.getters.getQuery
            }
            this.fetchCheckExpenses()
        },
        methods: {
            exportToPDF() {
                html2pdf(document.getElementById('element-to-convert'),
                         {
                             hotfixes: 'px_scaling',
                             margin: 1,
                             filename: 'expenses.pdf',
                             image: { type: 'jpeg', quality: 1 },
                             html2canvas: { scale: 2 },
                             jsPDF: { unit: 'px', orientation: 'landscape', format: [1500, 1080], putOnlyUsedFonts: true }
                         }
                )
            },
            filterResults(query, sort) {
                this.query = query
                this.sort = sort
                this.page = 1
                this.fetchCheckExpenses()
                this.fetchExpensesTotals()
            },
            reloadFilters() {
                this.fetchAllCategories()
                this.fetchAllChargeUnits()
                this.query = {}
                this.sort = null
                this.totals = {}
                this.fetchCheckExpenses()
            },
            togglePanel() {
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            onDelete(expense) {
                expenseService.deleteExpense(expense.id).then(() => this.fetchCheckExpenses())
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchCheckExpenses()
            },
            handleClick(action, item) {
                this.$router.push(`/expenses/${item.id}/${action}`)
            },
            createExpense() {
                this.$router.push(`/expenses/create`)
            },
            fetchCheckExpenses() {
                expenseService.getChecks(this.page, this.size, this.query, this.sort).then(resp => {
                    this.expenses = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            fetchAllCategories() {
                categoryService.getAllCategories().then(resp => {
                    this.displayInfo[4].data = resp.data
                })
            },
            fetchAllChargeUnits() {
                chargeUnitService.getAllChargeUnits().then(resp => {
                    this.displayInfo[3].data = resp.data
                })
            },
            fetchExpensesTotals() {
                expenseService.getTotals(this.query).then(resp => {
                    this.totals = resp.data
                })
            }
        }
    }
</script>

<style>
.v-expansion-panel-header__icon {
    display: none !important;
}
</style>

<style scoped>

.card-title {
    font-weight: 500;
    font-size: 1.25rem;
}
.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
